import { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";
import { api } from "../../lib/api";

const ID_RE = /^[A-Za-z0-9/_-]{3,40}$/;
const inject = (src, inline) => { if (src) { const s = document.createElement("script"); s.async = true; s.src = src; document.head.appendChild(s); } if (inline) { const s = document.createElement("script"); s.text = inline; document.head.appendChild(s); } };

export function Pixels() {
  const { pathname } = useLocation();
  const ready = useRef(false);
  useEffect(() => {
    if (/^\/admin/.test(pathname) || ready.current) return;
    ready.current = true;
    api.get("/public/site").then(({ data }) => {
      const p = data.pixels || {};
      if (ID_RE.test(p.meta)) inject(null, `!function(f,b,e,v,n,t,s){if(f.fbq)return;n=f.fbq=function(){n.callMethod?n.callMethod.apply(n,arguments):n.queue.push(arguments)};if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';n.queue=[];t=b.createElement(e);t.async=!0;t.src=v;s=b.getElementsByTagName(e)[0];s.parentNode.insertBefore(t,s)}(window,document,'script','https://connect.facebook.net/en_US/fbevents.js');fbq('init','${p.meta}');fbq('track','PageView');`);
      const g = [p.gads, p.ga4].filter((x) => ID_RE.test(x));
      if (g.length) { inject(`https://www.googletagmanager.com/gtag/js?id=${g[0]}`, `window.dataLayer=window.dataLayer||[];function gtag(){dataLayer.push(arguments)}gtag('js',new Date());${g.map((id) => `gtag('config','${id}');`).join("")}`); window.__kouohGads = p.gads; }
    }).catch(() => {});
  }, [pathname]);
  useEffect(() => {
    if (/^\/admin/.test(pathname)) return;
    if (window.fbq) window.fbq("track", "PageView");
    if (window.gtag) window.gtag("event", "page_view", { page_path: pathname });
    if (pathname === "/demande/confirmation") { if (window.fbq) window.fbq("track", "Lead"); if (window.gtag) window.gtag("event", "generate_lead", { send_to: window.__kouohGads || undefined }); }
  }, [pathname]);
  return null;
}
